import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Field, Select } from "@conserveit/blocks";
import { connect } from "react-redux";
import { orderObjectArrayByKey } from "../../../utils/sorting";
import { updateSelectedProject } from "../../../redux/modules/reportGenerator";
import DynamicFormComponent from "./DynamicFormComponent";

@connect(
  (state) => ({
    user: state.auth.user,
    isFormDisabled: state.reportGenerator.isFormDisabled,
    selectedProject: state.reportGenerator.selectedProject,
  }),
  {
    updateSelectedProject,
  },
  null,
  { forwardRef: true }
)
export default class ProjectSelect extends DynamicFormComponent {
  static propTypes = {
    user: PropTypes.object.isRequired,
    isFormDisabled: PropTypes.bool.isRequired,
    selectedProject: PropTypes.string,
  };

  // TODO: This should be factored out into something that can be shared,
  // Ideally with a collection of other commonly-accessed endpoints, rather
  // than keeping everything in redux.
  static getAllProjects({ token }) {
    return axios.get("/projects/");
  }

  constructor(props) {
    super(props);
    this.state = {
      isFormValid: true,
      projectList: props.user.project.map((project) => ({
        label: project,
        value: project,
      })),
    };
  }

  componentDidMount() {
    // If the user has viewAllProjects access level, request list of all projects...
    // ... otherwise the project list will default to the user's member projects
    if (this.props.user.access.includes("viewAllProjects")) {
      this.setProjectList();
    }
  }

  setProjectList() {
    const request = ProjectSelect.getAllProjects(this.props.user);

    request
      .then(({ data }) => {
        // Mapping the returned `jira_key` and `project_name` to the option-compatible 'label` and `value`
        // Then sorting the options alphabetically by the project name (label)
        const projectList = data.map(
          ({ jira_key: key, project_name: name }) => ({
            label: name,
            value: key,
          })
        );

        this.setState({
          projectList: orderObjectArrayByKey(projectList, "label"),
        });
      })
      .catch((err) => {
        // If the request fails, we don't update the project list, and so only the projects
        // that the user is a member of will be displayed
        console.warn(
          `Something went wrong retrieving the list of projects, defaulting to user's projects... Error: ${err}`
        );
      });
  }

  handleProjectChange = (project) => {
    this.setState({ isFormValid: true });
    this.props.updateSelectedProject(project.value);
  };

  validate = () => {
    if (
      !this.props.selectedProject ||
      this.props.selectedProject.length === 0
    ) {
      this.setState({ isFormValid: false });
      return false;
    }
    return true;
  };

  getSelectedValues = () => {
    return { projectKey: this.props.selectedProject };
  };

  render() {
    return (
      <Field
        name="form-select-project"
        label="Project"
        isValid={this.state.isFormValid}
        error={!this.state.isFormValid && "Project is required"}
      >
        {({ name, id, error }) => (
          <Select
            placeholder="Select Project"
            clearable={false}
            error={error}
            name={name}
            id={id}
            disabled={this.props.isFormDisabled}
            options={this.state.projectList}
            onChange={this.handleProjectChange}
          />
        )}
      </Field>
    );
  }
}
